import type { Persona } from "@/features/personas/types/personas.types";

/**
 * Whether a persona may be put in a new set at all, independent of which industry
 * is selected. `assertPersonasBelongToTenant` enforces the same rule server-side.
 */
export function isPersonaSelectable(persona: Persona): boolean {
  if (persona.hiddenAt != null) return false;
  return persona.status === "ACTIVE" || persona.status === "SUGGESTED";
}

/**
 * Personas selectable in the create-set dialog for a chosen industry.
 *
 * Includes every ACTIVE or SUGGESTED core-suggested persona for the tenant, plus
 * ACTIVE or SUGGESTED industry-suggested personas whose `industry` matches the
 * selection. Hidden and REJECTED rows are never offered.
 */
export function filterPersonasByIndustry(
  personas: readonly Persona[],
  industry: string | null | undefined,
): Persona[] {
  const selected = industry?.trim();
  if (!selected) return [];

  return personas.filter((persona) => {
    if (!isPersonaSelectable(persona)) return false;
    if (persona.type === "CORE_SUGGESTED") return true;
    return persona.type === "INDUSTRY_SUGGESTED" && persona.industry === selected;
  });
}
